import _ from 'lodash';

import { enterpriseContractType } from 'bundles/enterprise-admin-constants/EnterpriseContractConstants';
import { requireFields } from 'bundles/naptimejs/util/requireFieldsDecorator';

import NaptimeResource from './NaptimeResource';

const { SELF_SERVE, STANDARD } = enterpriseContractType;

const enterpriseContractFields = [
  'enterpriseContractId',
  'contractTags',
  'planId',
  'startsAt',
  'endsAt',
  // 'renewsAt', // deprecated
  'properties',
  'limits',
  'value',
  'refundDeadline',
  'amountRemaining',
  'previousPayments',
  // 'futurePayments', // deprecated
  'isRefunded',
  'amountRefunded',
  'billingType',
  'billingSystemType',
  'terms',
  'currencyCode',
  'autoRenewInformation',
  'remainingTermPayments',
  'endedAt',
  'terminationReason',
  'nextPaymentInformation',
  'contractState',
  'isPriceFluctuationPossible',
];

class DecoratedEnterpriseContracts extends NaptimeResource {
  static RESOURCE_NAME = 'decoratedEnterpriseContracts.v1';

  static byEnterpriseContractId(enterpriseContractId) {
    return this.get(
      enterpriseContractId,
      {
        fields: enterpriseContractFields,
      },
      (contract) => contract || null
    );
  }

  static byThirdPartyOrganization(thirdPartyOrganizationId) {
    return this.finder('byThirdPartyOrganization', {
      params: {
        id: thirdPartyOrganizationId,
      },
      fields: enterpriseContractFields,
    });
  }

  @requireFields('properties')
  get paymentWalletId() {
    return this.properties?.selfServeProperties?.paymentWalletId;
  }

  @requireFields('renewsAt')
  get isAutoRenewActive() {
    return this.isNonLegacyContract && !!this.autoRenewInformation.renewsAt;
  }

  get isAutoRenewEnabled() {
    return this.coursesPerUserLimit !== 1;
  }

  @requireFields('terms')
  get isNonLegacyContract() {
    return this.terms && this.terms.length > 0;
  }

  @requireFields('limits')
  get coursesPerUserLimit() {
    return (this.limits && this.limits.coursesPerUserLimit) || 'Unlimited';
  }

  @requireFields('limits')
  get userLimit() {
    return (this.limits && this.limits.userLimit) || 'Unlimited';
  }

  @requireFields('contractType')
  get isSelfServeContract() {
    return this.contractType === SELF_SERVE;
  }

  @requireFields('contractType')
  get isStandardContract() {
    return this.contractType === STANDARD;
  }

  @requireFields('limits')
  get enrollmentCapLimit() {
    return this.limits.enrollmentCapLimit || 'Unlimited';
  }

  @requireFields('previousPayments')
  get latestTransaction() {
    // Only functions if naptime has retrieved the object with previousPayments
    if (!this.previousPayments) {
      return undefined;
    }

    const sorted = _.sortBy(this.previousPayments, 'paymentAt');
    return sorted[sorted.length - 1];
  }
}

export default DecoratedEnterpriseContracts;
